import { SET_LOADING } from '../constants/actionTypes';

export const setLoading = payload => ({
  type: SET_LOADING,
  payload
});
